import { useEffect } from "react"

const useTitle = title =>{

    useEffect( () =>{
        document.title = `${title} - Fitfinity`;
    }, [title])
};


export default useTitle;